import type {UserPlatformAccess} from 'src/openapi/admin/models/UserPlatformAccess';
import type {UserSearchCriteria} from 'src/openapi/admin/models/UserSearchCriteria';

export type UsersFilters = Pick<UserSearchCriteria, 'groupId' | 'platformAccess' | 'productExternalKeys'>;

export const platformAccessKey = ({type, status}: UserPlatformAccess) => `${type}:${status}`;

export const getUsersFilters = (criteria: UserSearchCriteria): UsersFilters => ({
    ...criteria.groupId ? {groupId: Number(criteria.groupId)} : {},
    ...criteria.productExternalKeys?.length ? {productExternalKeys: [...new Set(criteria.productExternalKeys)]} : {},
    ...criteria.platformAccess?.length ? {platformAccess: criteria.platformAccess} : {},
});

export const applyUsersFilters = (criteria: UserSearchCriteria, filters: UsersFilters): UserSearchCriteria => {
    const {groupId, platformAccess, productExternalKeys, userTypes, userStatuses, ...other} = criteria;
    return {...other, ...getUsersFilters(filters)};
};
